import { useState } from 'react';
import Tabs from 'components/common/Tabs';
import { tabNames } from './constants';
import { GithubSettings } from './github';
import { RepositoryManager } from './repositories';
export const Settings = () => {
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <div className="settings-page">
      <div className="tabs-container">
        <Tabs value={tabValue} labels={tabNames} onChange={handleTabChange} />
        <div className="details-container">
          {tabValue === '1' && <RepositoryManager />}
          {tabValue === '2' && <GithubSettings />}
        </div>
      </div>
    </div>
  );
};
